import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollThreshold = 300;

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, y: 50 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 50 }}
          whileHover={{ y: -5 }}
          whileTap={{ scale: 0.95 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 group outline-none"
          aria-label="Scroll to top"
        >
          {/* Outer Glow (Visible on Hover) - Creates a soft shadow effect */}
          <div className="absolute inset-0 rounded-2xl bg-[#2a3890] blur-lg opacity-0 group-hover:opacity-40 transition-opacity duration-500 translate-y-2 scale-90" />

          {/* Glassy Button Container */}
          <div className="relative flex items-center justify-center w-14 h-14 rounded-2xl bg-white/40 backdrop-blur-md shadow-lg overflow-hidden transition-all duration-300 group-hover:border-[#2a3890]/30">
            
            {/* Gradient Background (Fade in on Hover) */}
            <div className="absolute inset-0 bg-gradient-to-tr from-[#2a3890] to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            
            {/* Arrow Icon */}
            <ArrowUp 
              className="relative z-10 w-6 h-6 text-[#2a3890] group-hover:text-white transition-colors duration-300" 
              strokeWidth={3}
            />

            {/* Subtle Shine/Reflection Overlay */}
            <div className="absolute -inset-full top-0 block h-full w-1/2 -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-shine" />
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopButton;